<template>
    <div class="tournament-overlay" @click.self="goBack">
        <div class="tournament-overview-container" @click.self="goBack">
            <TournamentOverview :tournament-id="tournamentId" />
        </div>
    </div>
</template>

<script>
import TournamentOverview from '../../../views/Tournament/views/TournamentOverview.vue';

export default {
    name: 'TournamentOverviewWrapper',
    components: { TournamentOverview },
    props: {
        tournamentId: {
            type: Number,
            required: true
        }
    },
    created() {
        document.documentElement.style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.documentElement.style.overflow = '';
    },
    methods: {
        goBack() {
            this.$router.back();
        }
    }
}
</script>

<style lang="scss">
.tournament-overlay {
    .tournament-overview-container {
        .tournament-rank-view {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
}
</style>

<style scoped lang="scss">
.tournament-overlay {
    position: fixed;
    z-index: 3;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);

    .tournament-overview-container {
        margin: 0 auto;
        height: 100%;
        background-color: #f8f9fa;
        overflow-y: auto;
        padding: 40px 60px 40px 118px;

        @media (max-width: 960px) {
            padding: 40px 60px 40px 60px;
        }

        .tournament-rank-view {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
    }
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
